import { useListServerInstances } from '@/services/server'
import { ServerViewSortKeys } from '@/pages/DashboardServers/types'

export const useHasServers = () => {
  const { data, isLoading, isError } = useListServerInstances({
    showAllUsers: false,
    sort: ServerViewSortKeys.STARTED_AT_DESC,
    searchText: '',
    staleTime: 60000, // Cache for 1 minute
  })

  const hasServers = data && data.total && data.total > 0

  return {
    hasServers: !!hasServers,
    isLoading,
    isError,
    totalServers: data?.total || 0,
  }
}